export { default as VotePollMutation } from "./VotePollMutation.graphql";
export { default as PollUpdatedSubscription } from "./PollUpdatedSubscription.graphql";
